export default (value, config = {}) => {
  value = value.replace ? value.replace(/,/g, '') : value

  let options = { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2, 
  };

  if (config.displaySymbol) {
    options.style = 'currency'
    options.currency = 'USD'
  }

  const number = new Intl.NumberFormat("en-US", options).format(value);
  
  return number;
};
